<template>
  <div class="pic-wrap">
    <div class="pic-item"
      v-for="(item, index) in dataList"
      :key="index">
      <img :src="appConfig.baseImgUrl + item.accessSrc"
        alt=""
        @click="openPicDialog">
      <p class="name">{{ item.id }}</p>
    </div>
  </div>
  <a-pagination
    style="text-align: center"
    :current="page.pageNum"
    show-quick-jumper
    :pageSize="10"
    :total="total"
    :show-total="total => `共 ${total} 条`"
    @change="getDataItems"
  ></a-pagination>
  <PicDialog ref="picDialog" :list="dataList"></PicDialog>
</template>
<script>
import { mapState } from 'vuex'
import PicDialog from './PicDialog'
import { getDatasetItem } from '@/api/dataSet'
export default {
  props: {
    datasetId: {
      type: String,
      default: ''
    }
  },
  components: {
    PicDialog
  },
  data () {
    return {
      dataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0
    }
  },
  emits: ['settotal'],
  computed: {
    ...mapState(['appConfig'])
  },
  methods: {
    reset () {
      this.dataList = []
      this.$nextTick(() => {
        this.getDataItems(1)
      })
    },
    getDataItems (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getDatasetItem({
        datasetId: this.datasetId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(res => {
        this.total = res.total
        this.$emit('settotal', this.total)
        this.dataList = res.data
      })
    },
    openPicDialog () {
      this.$refs.picDialog.open()
    }
  }
}
</script>
